// extracted by mini-css-extract-plugin
export default {"grid":"index_grid_YmDNx","gridChildren":"index_gridChildren_FWHte","mask":"index_mask_ErSbd","title":"index_title_9xF4t"};